<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const tabs = [
  {
    to: '/search/contact',
    title: 'Contact Information'
  },
  {
    to: '/search/policy',
    title: 'Policy Number'
  }
]

const route = useRoute()

const selectedTab = computed(() => tabs.find((tab) => tab.to === route.path))
</script>

<template>
  <div class="relative">
    <div class="bg-primary pt-8 pb-12 text-white md:px-12 px-8 shadow-b shadow-inner">
      <h1 class="md:text-4xl text-3xl text-white leading-tight mb-8 md:text-left text-center">
        Pet Parent &amp; Policy Holder Search
      </h1>
    </div>
    <div class="w-full mx-auto md:px-12 px-8 pb-4 -mt-14">
      <div class="flex flex-col rounded border border-[#ccc] bg-[#efecf7]">
        <span class="p-4 pb-0 md:hidden block">Search by:</span>
        <div class="flex items-center border-b border-[#ccc] px-4">
          <router-link
            v-for="(tab, index) in tabs"
            :key="index"
            :to="tab.to"
            :class="[
              'border-b-2 focus:outline-none focus:background-[#ddd] leading-tight md:flex-initial flex-1 md:text-left text-center focus-visible:border-secondary focus-visible:text-secondary p-4',
              {
                'border-b-transparent': selectedTab?.to !== tab.to,
                'border-b-primary focus-visible:border-b-primary': selectedTab?.to === tab.to
              }
            ]"
          >
            <span class="md:inline hidden">Search by</span>
            {{ tab.title }}
          </router-link>
        </div>
        <div class="p-4 bg-white rounded-b">
          <nuxt-page />
        </div>
      </div>
    </div>
  </div>
</template>
